import { apiCall, API } from '../../utils/APIFunctions';

export function fetchSuperfolders() {
  return apiCall(`${API}/superfolders`, "GET");
}
